var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"time"},[_vm._v(_vm._s(String(_vm.hours).padStart(2,"0"))+":"+_vm._s(String(_vm.minutes).padStart(2,"0"))+":"+_vm._s(String(_vm.seconds).padStart(2,"0")))])])}
var staticRenderFns = []

export { render, staticRenderFns }